export const SELECT_MENU = 'SELECT_MENU';
